import React from "react";

import { copy } from "shared/assets";
import { Venue } from "shared/assets/icons";
import { ButtonContainer, Card, FancyButtonLink, Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { IStatus } from "shared/types";
import { EditStage, EditStageCapacity } from "Venues/containers";
import { useStagePageContext, useVenuePageContext } from "Venues/contexts";

const EditStagePage: React.FC = () => {
  const { openDeleteStageModal, userPermissions, fetchingVenue } = useVenuePageContext();
  const { stageId, setStageHeaderPlaceholder } = useStagePageContext();

  if (fetchingVenue) return <Loader />;

  return (
    <>
      <Card icon={Venue} title={copy.editStage.title}>
        <Spacer size="l">
          <EditStage updatePlaceholder={setStageHeaderPlaceholder} />
          <EditStageCapacity key={stageId} />
          {userPermissions.DELETE && (
            <ButtonContainer>
              <FancyButtonLink
                status={IStatus.error}
                onClick={() => stageId && openDeleteStageModal(stageId)}
              >
                {copy.deleteStage.cta}
              </FancyButtonLink>
            </ButtonContainer>
          )}
        </Spacer>
      </Card>
    </>
  );
};

export default EditStagePage;
